import {
  AccessoryGroup,
  AccessoryPick,
  defaultAccessoryOption,
  toAccessoryPick
} from 'utils/ducted-accessory-groups';

export type AccessorySelectionCombination = {
  combinationId: number;
  accessoryGroups: AccessoryGroup[];
};

export type AccessorySelections = Map<string, AccessoryPick>;

export const accessorySelectionKey = (
  combinationId: number,
  accessoryTypeCode: string
): string => `${combinationId}:${accessoryTypeCode}`;

export const defaultAccessorySelections = (
  combinations: ReadonlyArray<AccessorySelectionCombination>
): AccessorySelections =>
  new Map(
    combinations.flatMap((combination) =>
      combination.accessoryGroups.map((group): [string, AccessoryPick] => [
        accessorySelectionKey(
          combination.combinationId,
          group.accessoryTypeCode
        ),
        toAccessoryPick(defaultAccessoryOption(group))
      ])
    )
  );

export const addSystemsButtonText = (systemCount: number): string =>
  systemCount === 1 ? 'Add System' : 'Add Systems';
